export default __webpack_public_path__ + "static/media/6.32a138b3.png";